<template>
  <div class="invoice-detail-line">
    <div class="invoice-detail-line-cell">
      <span><router-link :to="{name: 'deliveryformdetails', params: {delivery_form_id: lineData.tnbl}}">{{lineData.tnbl}}</router-link></span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{this.$dateformat(lineData.tdate_bl)}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{lineData.tlib_trsp}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{lineData.tnb_colis}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{lineData.tpds_brut}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{lineData.tstatus}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span><a v-if="lineData.thttp_track !== ''" target="_blank" :href="lineData.thttp_track">{{$_('tracking_link')}}</a></span>
    </div>
    <div class="invoice-detail-line-cell">
      <span>{{lineData.tmont_ttc}} {{lineData.tcdev}}</span>
    </div>
    <div class="invoice-detail-line-cell">
      <span class="invoice-pdf" @click="vDownloadBL"><i class="material-icons">get_app</i></span>
    </div>
  </div>
</template>

<script>

import deliveryService from '@/modules/facture/services/deliveryService';

export default {
    props: ['dataline', 'index'],
    name:'InvoiceDetailsLine',
    data() {
      return {
        lineData: {
          tnbl: this.$props.dataline.TNBL,
          tdate_bl: this.$props.dataline.TDATE_BL,
          tlib_trsp: this.$props.dataline.TLIB_TRSP,
          tnb_colis: this.$props.dataline.TNB_COLIS,
          tpds_brut: this.$props.dataline.TPDS_BRUT,
          tstatus: this.$props.dataline.TSTATUS,
          thttp_track: this.$props.dataline.THTTP_TRACK,
          tmont_ttc: this.$props.dataline.TMONT_TTC,
          tcdev: this.$store.getters['application/get_application_customer'].TCDEV
        }
      }
    },
    methods: {
      vDownloadBL() {
        deliveryService.getDownloadBL(this.$props.dataline.TNBL)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.lineData.tnbl+'.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.error(err);
        });
      }
    }
}
</script>

<style scoped>
.invoice-detail-line {
  display: flex;
  border: solid 1px #E9E9E9;
  margin-top: 10px;
  transition: all .3s;
  align-items: center;
}
.invoice-detail-line-cell {
  display: flex;
  width: calc(100% / 9);
  justify-content: center;
  padding: 25px 0px;
}
.invoice-detail-line-cell span {
  color:#585858;
  font-size: var(--fz-md);
  transition: all .3s;
}
.invoice-detail-line:hover {
  background-color: #F5F5F5;
  cursor: pointer;
}
.invoice-detail-line:hover .invoice-detail-line-cell span {
  color: #8B8B8B;
}
.invoice-pdf{
  padding: 3px;
  border-style: solid;
  border-width: 1px;
}
.invoice-pdf:hover{
  background: #DDD;
}
</style>